export default "__VITE_ASSET__B1VM0w0W__"